import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const ban: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M10.25-5.031c0-.832-.227-1.598-.672-2.297l-5.89 5.875A4.1 4.1 0 0 0 6-.75a4.1 4.1 0 0 0 1.656-.344 4.187 4.187 0 0 0 2.25-2.266 4.2 4.2 0 0 0 .344-1.671M2.453-2.687l5.89-5.891A4.07 4.07 0 0 0 6-9.297a4.17 4.17 0 0 0-2.14.578 4.2 4.2 0 0 0-1.547 1.547 4.24 4.24 0 0 0-.563 2.14q0 1.267.703 2.345m9.063-4.672a5.912 5.912 0 0 1 0 4.688A6 6 0 0 1 10.25-.75 5.9 5.9 0 0 1 8.328.516 5.8 5.8 0 0 1 6 1C5.188 1 4.41.836 3.672.516A6 6 0 0 1 1.75-.75 6.2 6.2 0 0 1 .469-2.672 6 6 0 0 1 0-5.016q0-1.23.469-2.343c.32-.75.75-1.391 1.281-1.922a6 6 0 0 1 1.922-1.281A5.8 5.8 0 0 1 6-11.047a5.8 5.8 0 0 1 2.328.485c.75.312 1.39.742 1.922 1.28a5.9 5.9 0 0 1 1.266 1.923m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11.047)"
    />
  ),
  svgProps: {
    height: "12.047",
    width: "12",
  }
};